import React from 'react';
import { useEffect, useState } from 'react';
import {Switch, Route, Link} from "react-router-dom";

import Signin from "./components/Signin";
import Signup from "./components/Signup";
import NavBar from "./components/Navbar";
import Checkout from "./components/Checkout";
import Home from "./components/Home";

import './App.css';




function App() {

  
  return (
    <div className = "App">
      <NavBar/>
      <Switch>
        <Route exact path = '/signin' component= {Signin}/>
        <Route path = '/signup' component= {Signup}/>
        <Route path = '/checkout' component= {Checkout}/>
        <Route path = '/home' component={Home}/>
        <Route component = {Home}/>
      </Switch>
      
    </div>
  );
}

export default App;
